import React from 'react'
import { Input } from '@amzn/awsui-components-react'

const TableInputTemplate = (props) => {
    const { id, description, inputName, onInputChange, disabled } = props

    return (
        <Input
            disabled={disabled}
            value={description}
            onChange={({ detail }) => onInputChange(id, inputName, detail.value)}
        ></Input>
    )
}

export default TableInputTemplate
